import { MangoResponse, MangoSelector } from 'nano';
export class PouchDbQueryHelper {
  private shouldLogDetails: boolean = process.env.DEBUG === '1';

  constructor(private db: any, private tag: string, private logger?: any|undefined) {
  }

  public async queryAndGetDocs(info: string, queryOptions: any): Promise<any[]> {
    const start = Date.now();
    const result = await this.db.find(queryOptions);
    const time = Date.now() - start;

    const warning = this.getWarningLogMessageFromResult(result);
    this.log(`${info} took ${time}msec to return ${result.docs.length} docs ${warning}`, queryOptions);

    return result.docs;
  }

  // Note that the entity from db might not match the interface types, eg Date field are set as ISOStrings
  // the mapToEntity should make sure the returned types are mapped to the correct enity types
  public async queryFieldsAndMap<IResult>(
      info: string, queryOptions: MangoSelector,
      getFields: () => string[],
      mapToEntity: (db: IResult & {_id: string, _rev: string}) => IResult): Promise<IResult[]> {
    if (queryOptions.fields) {
      throw Error('Fields will be auto calculated from the interface properties.');
    }
    queryOptions = {...queryOptions, fields: getFields()};

    const start = Date.now();
    const result = await this.db.find(queryOptions) as MangoResponse<IResult & {_id: string, _rev: string}>;
    const time = Date.now() - start;

    const warning = this.getWarningLogMessageFromResult(result);
    this.log(`${info} took ${time}msec to return ${result.docs.length} docs ${warning}`, queryOptions);

    const mapped = result.docs.map(mapToEntity);
    return mapped;
  }

  public async getAllDocsAsRows(): Promise<any[]> {
    const start = Date.now();
    const result = await this.db.allDocs({ include_docs: true });
    const time = Date.now() - start;

    const warning = this.getWarningLogMessageFromResult(result);
    this.log(`allDocs took ${time}msec to return ${result.rows.length} rows ${warning}`);

    return result.rows;
  }

  public async queryView(view: string, queryOptions: any): Promise<any[]> {
    const start = Date.now();
    const result = await this.db.query(view, queryOptions);
    const time = Date.now() - start;

    const warning = this.getWarningLogMessageFromResult(result);
    this.log(`queryView took ${time}msec to return ${result.rows.length} rows ${warning}`);

    return result.rows;
  }

  public async bulkGet(documentIds: string[]): Promise<any[]> {
    const start = Date.now();
    const result = await this.db.allDocs({
      keys: documentIds,
      include_docs: true,
    });
    const time = Date.now() - start;

    const warning = this.getWarningLogMessageFromResult(result);
    this.log(`bulkGet took ${time}msec to return ${result.rows.length} rows ${warning}`);
    return result.rows
    .filter((row: any) => !!row.doc)
    .map((row: any) => row.doc);
  }

  private log(message: string, queryOptions?: any) {
    if (this.logger && this.logger.info) {
      const details = this.shouldLogDetails && queryOptions ? JSON.stringify(queryOptions, null, 2) : '';
      this.logger.info(`${this.tag} ${message} ${details}`);
    }
  }

  private getWarningLogMessageFromResult(result: any): string {
    if (result.warning) {
      return `with warning: ${result.warning}`;
    }
    return '';
  }
}
